import {PAYMENT_TYPES_DATA} from "../../constants/ActionTypes";

const INIT_STATE = {
    paymentTypes: [],
};

const paymentTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case PAYMENT_TYPES_DATA: {
            return {
                ...state,
                paymentTypes: action.payload,
            }
        }
        default:
            return state;
    }
}

export default paymentTypeReducer;
